import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { AssetAvailabilityComponent } from './asset-availability.component';
import { AuthGuard } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { ItemArrowComponent } from '../../core/components/item-arrow/item-arrow.component';
import { FiltersModule } from 'src/app/filters/filters.module';
import { GeographyStatsComponent } from './geography-stats.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'asset-availability/:categoryId/:productTypeId',
        component: AssetAvailabilityComponent,
        canActivate: [AuthGuard],
      },
    ]),
    CommonModule,
    CoreModule,
    MatTooltipModule,
    NgChartsModule,
    ItemArrowComponent,
    FiltersModule,
  ],
  providers: [],
  declarations: [AssetAvailabilityComponent, GeographyStatsComponent],
})
export class AssetAvailabilityModule {}
